module.exports = __webpack_public_path__ + "assets/img/sbac_header_navbar_desk_arrow.webp?a92d66a076a79257fd2981b6d30c3e58";